<div class="command-request-details">
  <div class="command-request-details__container" *ngIf="!loading;else loadingTemplate">
    <div class="command-request-details__container__header-container">
      <div class="command-request-details__container__header-container__header lx-section-title">Command ID
        {{commandRequestDetails.id}}</div>
      <div class="command-request-details__container__header-container__close lx-section-title" (click)="close()"><i
          class="lx-icon lx-close-x"></i></div>
    </div>
    <div class="command-request-details__container__body">
      <div class="command-request-details__container__body__status lx-body"><span
          class="progressStatus {{statusCss}}"></span>{{commandRequestDetails.status}}</div>
      <div class="command-request-details__container__body__devices-total lx-label">Devices
        ({{commandRequestDetails.deviceCount}} Total)</div>

      <div class="command-request-details__container__body__details" *ngIf="commandRequestDetails.inProgressCount > 0">
        <div class="command-request-details__container__body__details__header lx-label">In Progress
          ({{commandRequestDetails.inProgressCount}})</div>
        <div class="command-request-details__container__body__details__body lx-body">
          {{commandRequestDetails.inProgressSerialNumbers}}</div>
      </div>

      <div class="command-request-details__container__body__details" *ngIf="commandRequestDetails.completeCount > 0">
        <div class="command-request-details__container__body__details__header lx-label">Complete
          ({{commandRequestDetails.completeCount}})</div>
        <div class="command-request-details__container__body__details__body lx-body">
          {{commandRequestDetails.completeSerialNumbers}}</div>
      </div>

      <div class="command-request-details__container__body__details" *ngIf="commandRequestDetails.errorCount > 0">
        <div class="command-request-details__container__body__details__header lx-label">Error
          ({{commandRequestDetails.errorCount}})</div>
        <div class="command-request-details__container__body__details__body lx-body">
          {{commandRequestDetails.errorSerialNumbers}}</div>
      </div>

      <div class="command-request-details__container__body__details">
        <div class="command-request-details__container__body__details__header lx-label">Command</div>
        <div class="command-request-details__container__body__details__body lx-body">{{commandRequestDetails.command}}
        </div>
      </div>

      <div class="command-request-details__container__body__details">
        <div class="command-request-details__container__body__details__header lx-label">Issue Date</div>
        <div class="command-request-details__container__body__details__body lx-body">
          {{commandRequestDetails.requestedDate}}</div>
      </div>

      <div class="command-request-details__container__body__details">
        <div class="command-request-details__container__body__details__header lx-label">Issuer Name</div>
        <div class="command-request-details__container__body__details__body lx-body">
          {{commandRequestDetails.requesterName}}</div>
      </div>

      <div class="command-request-details__container__body__details">
        <div class="command-request-details__container__body__details__header lx-label">Description</div>
        <div class="command-request-details__container__body__details__body lx-body">
          {{commandRequestDetails.description}}</div>
      </div>


    </div>
  </div>

  <ng-template #loadingTemplate>loading</ng-template>

  <div class="command-request-details__button-container">
    <button class="command-request-details__button-container__button lx-btn lx-btn-secondary"
      (click)="close()"><span>Close</span></button>
  </div>
</div>
